import { Box, Flex, Spinner, Text } from "@chakra-ui/react";
import { logError } from "infra/packages/@sentry/logError";
import { useEffect, useState } from "react";
import Fade from "react-fade-in";
import Camera, { FACING_MODES } from "react-html5-camera-photo";
import "react-html5-camera-photo/build/css/index.css";
import SelectBaseAntd from "ui/components/Input/SelectBaseAntd";

interface CameraViewProps {
  onClose?: () => any;
  onSubmit: (uri: string) => any;
}

function CameraView({ onClose, onSubmit }: CameraViewProps) {
  const [loading, setLoading] = useState(true);
  const [devices, setDevices] = useState<MediaDeviceInfo[]>([]);
  const [selectedDevice, setSelectedDevice] = useState<string>(
    FACING_MODES.USER
  );

  useEffect(() => {
    const _devices: MediaDeviceInfo[] = [];

    try {
      navigator.mediaDevices.enumerateDevices().then((devices) => {
        devices.forEach((device) => {
          if (device.kind === "videoinput") {
            _devices.push(device);
          }
        });

        setDevices(_devices);
        setLoading(false);
      });
    } catch (err) {
      setLoading(false);
      console.log(err);
      logError(err);
    }
  }, []);

  return (
    <Flex flexDir="column" h="100%" flex={1}>
      {!devices.length && loading ? (
        <Flex h="100%" justifyContent="center" alignItems="center">
          <Spinner />
        </Flex>
      ) : null}

      {!devices.length && !loading ? (
        <Text textAlign="center" size="md">
          Nenhuma câmera detectada
        </Text>
      ) : null}

      {devices.length ? (
        <>
          <Text mb={2}>Câmera</Text>
          <Box mb={4}>
            <SelectBaseAntd
              size="large"
              getPopupContainer={(node) => node.parentNode}
              placeholder="Selecione"
              style={{ width: "100%" }}
              value={selectedDevice}
              onChange={(ev) => {
                setSelectedDevice(ev);
              }}
              options={[
                {
                  value: FACING_MODES.USER,
                  label: "Padrão",
                },
                ...devices.map((device) => ({
                  value: device.deviceId,
                  label: device.label,
                })),
              ]}
            />
          </Box>

          <Flex flex={1} flexDir="column" justifyContent="center">
            <Fade key={selectedDevice} transitionDuration={500}>
              <Camera
                sizeFactor={0.75}
                imageCompression={0.95}
                idealFacingMode={selectedDevice as any}
                onTakePhoto={(dataUri) => {
                  onSubmit(dataUri);
                  onClose?.();
                }}
              />
            </Fade>
          </Flex>
        </>
      ) : null}
    </Flex>
  );
}

export default CameraView;
